// listener that listens for changes in newConversationAlert, newConversationMessageAlert,
// newInboxMessageAlert and newPromptAlert.
import {
  doc,
  collection,
  updateDoc,
  deleteDoc,
  onSnapshot,
  deleteField
} from 'firebase/firestore';
import { firestore } from '../firebase';
import { UPDATE_NEW_STUFF_ALERTS } from './types';

export const newStuffAlertsListener = () => async (dispatch, getState) => {
  const userID = getState().auth.currentUser.uid;
  try {
    const newStuffAlertsRef = collection(
      firestore,
      'usersPrivate',
      userID,
      'newStuffAlerts'
    );

    const unsubscribeNewStuffAlertsListener = onSnapshot(
      newStuffAlertsRef,
      snapshot => {
        const newStuffAlerts = {};
        snapshot.docs.forEach(docSnap => {
          const newStuffAlertId = docSnap.id;
          const newStuffAlertData = docSnap.data();
          newStuffAlerts[newStuffAlertId] = {
            ...newStuffAlertData
            // id: newStuffAlertId
          };
        });

        dispatch({
          type: UPDATE_NEW_STUFF_ALERTS,
          payload: {
            unsubscribeNewStuffAlertsListener,
            newStuffAlerts
          }
        });
      }
    );
  } catch (error) {
    console.error(error);
  }
};

// delete the conversation object in newConversationMessageAlert matching the conversationId
export const deleteSpecificNewConversationMessageAlert = conversationId => async (
  dispatch,
  getState
) => {
  const userID = getState().auth.currentUser.uid;
  try {
    const newConversationMessageAlertRef = doc(
      firestore,
      'usersPrivate',
      userID,
      'newStuffAlerts',
      'newConversationMessageAlert'
    );

    await updateDoc(newConversationMessageAlertRef, {
      [conversationId]: deleteField()
    });
  } catch (error) {
    console.error({ error });
  }
};

// deletes newInboxMessageAlert after visiting inboxpage/InboxMessages.js
export const deleteNewInboxMessageAlert = () => async (dispatch, getState) => {
  const userID = getState().auth.currentUser.uid;
  try {
    const newInfoboxMessageAlertRef = doc(
      firestore,
      'usersPrivate',
      userID,
      'newStuffAlerts',
      'newInboxMessageAlert'
    );

    await deleteDoc(newInfoboxMessageAlertRef);
  } catch (error) {
    console.error({ error });
  }
};
